var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20186)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.001 0.00244141H-0.0107422V45.0024H60.001V0.00244141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4258 13.6699L47.1838 4.31043L45.6239 5.35077L51.8659 14.7103L53.4258 13.6699ZM51.0859 15.2304L44.8439 5.87094L43.284 6.91127L49.526 16.2708L51.0859 15.2304ZM48.746 16.7909L42.504 7.43144L40.9441 8.47177L47.1861 17.8313L48.746 16.7909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22679 36.9487L17.0264 31.7471L16.5062 30.9671L8.70663 36.1688L9.22679 36.9487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3857 16.2725C37.7303 13.7902 35.1565 12.0672 32.2306 11.4825C29.3048 10.8979 26.2665 11.4995 23.7843 13.155C21.302 14.8105 19.579 17.3842 18.9943 20.3101C18.4097 23.2359 19.0113 26.2742 20.6668 28.7565L39.3857 16.2725Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3859 16.2723C41.0414 18.7546 41.643 21.7929 41.0584 24.7187C40.4737 27.6446 38.7507 30.2184 36.2684 31.8738C33.7862 33.5293 30.7479 34.1309 27.822 33.5463C24.8962 32.9616 22.3224 31.2386 20.667 28.7564C19.8392 27.5152 19.5384 25.9961 19.8307 24.5332C20.1231 23.0702 20.9846 21.7833 22.2257 20.9556C23.4668 20.1279 24.986 19.8271 26.4489 20.1194C27.9118 20.4117 29.1987 21.2732 30.0264 22.5144L39.3859 16.2723Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0263 22.5144C28.3027 19.9299 29.0005 16.4373 31.5851 14.7137C34.1696 12.99 37.6622 13.6879 39.3858 16.2724C41.1095 18.857 40.4116 22.3495 37.8271 24.0731C35.2425 25.7968 31.75 25.099 30.0263 22.5144Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7295 33.5718L48.0693 35.1323L48.5895 34.3524L46.2496 32.7919L45.7295 33.5718ZM13.7512 12.245L16.4811 14.0656L17.0012 13.2856L14.2714 11.465L13.7512 12.245ZM9.07147 9.12398L11.4113 10.6845L11.9315 9.90453L9.59164 8.34403L9.07147 9.12398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrSouthKorea);
export default __webpack_public_path__ + "static/media/kr South Korea.70856e70351358d1d64ac505ce991c29.svg";
export { ForwardRef as ReactComponent };